import React, { ComponentType, FunctionComponent } from "react";

export interface SvgIconProps extends React.SVGProps<SVGSVGElement> {}

const SvgIcon: (Icon: ComponentType<SvgIconProps>) => FunctionComponent<SvgIconProps> = (Icon) => ({
    className,
    style,
}) => <Icon className={className} style={style} />;

export default SvgIcon;
